import React, { PureComponent } from 'react';
import TextField from '@material-ui/core/TextField';
import { InputProps } from './Input.types';

class Input extends PureComponent<InputProps> {
  onChange = (e: React.ChangeEvent<HTMLInputElement>) => this.handleChange(e.target && e.target.value);
  handleChange = (value: string) => {
    this.props.setTitle(value);
  };
  render() {
    const { type, title, label, placeholder } = this.props;
    return <TextField label={label} value={title} placeholder={placeholder} onChange={this.onChange} type={type} />;
  }
}
export default Input;
